export const DefaultAvatar = './assets/img/default-avatar.png';

export const Timezone = 'America/Buenos_Aires';

export const TimezoneHourDiff = 3;
